import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
import { ErrorComponent } from './pages/errors/error/error.component';
import { PagesComponent } from './pages/pages.component';
import { AuthGuard } from 'src/guards/auth.guard';
import { AppointmentDetailsComponent } from './pages/scheduler/appointment-details/appointment-details.component';
import { SchedulerModule } from './pages/scheduler/scheduler.module';
import { SchedulerComponent } from './pages/scheduler/scheduler.component';
import { StandbyModule } from './pages/standby/standby.module';
import { CustomersModule } from './pages/customers/customers.module';
import { PatientsModule } from './pages/patients/patients.module';
import { TreatmentsModule } from './pages/treatments/treatments.module';
import { WaitlistModule} from './pages/waitlist/waitlist.module';
import { BrowserStateComponent } from './pages/browser-state/browser-state.component';


const routes: Routes = [  
  {
    path: '',
    component: PagesComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [      
      { path: 'scheduler', loadChildren: () => import('./pages/scheduler/scheduler.module').then(m => m.SchedulerModule), data: { breadcrumb: 'Scheduler' } },
      { path: 'standby', loadChildren: () => import('./pages/standby/standby.module').then(m => m.StandbyModule), data: { breadcrumb: 'StandBy' } },
      { path: 'search-customer', loadChildren: () => import('./pages/customers/customers.module').then(m => m.CustomersModule), data: { breadcrumb: 'Search' } },
      { path: 'patients', loadChildren: () => import('./pages/patients/patients.module').then(m => m.PatientsModule), data: { breadcrumb: 'Search' } },
      { path: 'search-treatment', loadChildren: () => import('./pages/treatments/treatments.module').then(m => m.TreatmentsModule), data: { breadcrumb: 'Search Treatment' } },
      { path: 'waitlist', loadChildren: () => import('./pages/waitlist/waitlist.module').then(m => m.WaitlistModule), data: { breadcrumb: 'Waitlist' }}
      
    ]
  },

  { path: 'welcome', loadChildren: () => import('./pages/welcome-page/welcome.module').then(m => m.WelcomeModule) },
  { path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule) },
  { path: 'forgot-password', loadChildren: () => import('./pages/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule) },
  { path: 'error', component: ErrorComponent, data: { breadcrumb: 'Error' } },
  { path: 'state', component: BrowserStateComponent, data: { breadcrumb: 'state' } },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [
    BrowserAnimationsModule,
    RouterModule.forRoot(
      routes,
      {
    enableTracing: false,
    preloadingStrategy: PreloadAllModules,
    relativeLinkResolution: 'legacy'
}
    ),
    SchedulerModule,
    StandbyModule,
    CustomersModule,
    PatientsModule,
    TreatmentsModule,
    WaitlistModule
  ],
  exports: [RouterModule]
 
})
export class AppRoutingModule { }
